export const stepConfig = [
  {target: '.ai-assistant', key: 'aiAssistant'},
  {target: '.TapyblAiHomeContainer', key: 'homeWelcome'},
  {target: '.microLessonsCard', key: 'microLessonsCard'},
];
